import { Helmet } from "react-helmet";
import { useSite } from "../../../_foundation/hooks/useSite";

interface SeoHeadProps {
  seo: Record<any, any>;
  defaultTitle: string;
  putEndingMark?: boolean;
}

function SeoHead({ seo, defaultTitle, putEndingMark = true }: SeoHeadProps) {
  const { storeDisplayName } = useSite();
  const storeName = storeDisplayName !== "LapeyreB2C" ? storeDisplayName : "Lapeyre";
  return (
    <Helmet>
      <meta name="description" content={seo?.description || ""}></meta>
      {seo?.metaKeyword && <meta name="keywords" content={seo.metaKeyword}></meta>}
      <title>
        {seo?.title || (putEndingMark ? `${defaultTitle} | ${storeName}` : `${storeName} - ${defaultTitle}`)}
      </title>
      <meta
        name="robots"
        content={`${seo?.index === false ? "noindex" : "index"}, ${seo?.follow === false ? "nofollow" : "follow"}`}
      />
      <link rel="canonical" href={window.location.href.split("?")[0]} />
    </Helmet>
  );
}

export { SeoHead };
